export default class WaterInsightsSeries {

    static S3CHL = 's3-chl';
    static S3TSM = 's3-tsm';
    static SST_GHRSST = 'sst-ghrsst';
}
